var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25116 13.7582C6.15144 13.7576 6.05289 13.7367 5.96157 13.6966C5.87025 13.6565 5.7881 13.5982 5.72016 13.5252L1.21916 8.7412C1.0782 8.5874 1 8.38634 1 8.1777C1 7.96907 1.0782 7.76801 1.21916 7.6142C1.28661 7.5407 1.36859 7.48202 1.45992 7.44187C1.55124 7.40173 1.64991 7.381 1.74966 7.381C1.84942 7.381 1.94809 7.40173 2.03941 7.44187C2.13073 7.48202 2.21272 7.5407 2.28016 7.6142L6.24916 11.8332L16.2192 1.2332C16.2866 1.1597 16.3686 1.10102 16.4599 1.06087C16.5512 1.02073 16.6499 1 16.7497 1C16.8494 1 16.9481 1.02073 17.0394 1.06087C17.1307 1.10102 17.2127 1.1597 17.2802 1.2332C17.4211 1.38701 17.4993 1.58807 17.4993 1.7967C17.4993 2.00534 17.4211 2.2064 17.2802 2.3602L6.77916 13.5252C6.71145 13.5985 6.62934 13.657 6.53797 13.6971C6.4466 13.7372 6.34794 13.758 6.24816 13.7582H6.25116Z",
    fill: "#7ED321",
    stroke: "#7ED321",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.aa134cd9.svg";
export { ForwardRef as ReactComponent };